module.exports = __webpack_public_path__ + "img/per.e10a88ba.svg";